/* AniMALL · Aviso de reabasto (Klaviyo Back in Stock, API cliente) · 2026-10-05 */
(function () {
  'use strict';
  var ENDPOINT = 'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=';
  var ENDPOINT_NEWSLETTER = 'https://a.klaviyo.com/client/subscriptions/?company_id=';
  var REVISION = '2026-07-15';
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function init(box) {
    if (box.getAttribute('data-ready') === '1') return;
    box.setAttribute('data-ready', '1');
    // Colocar la caja justo debajo de los botones de compra de la ficha.
    var host = document.getElementById('MainProduct-' + box.getAttribute('data-section-id'));
    var anchor = host && host.querySelector('.product__buttons');
    if (!anchor) { box.parentNode && box.parentNode.removeChild(box); return; }
    anchor.parentNode.insertBefore(box, anchor.nextSibling);
    box.setAttribute('data-placed', '1');
    var form = box.querySelector('form');
    var email = form.querySelector('[name="email"]');
    var variantInput = form.querySelector('[name="variant"]');
    var button = form.querySelector('button[type="submit"]');
    var optin = form.querySelector('[name="newsletter"]');
    var msg = box.querySelector('.animall-reabasto__msg');
    var scope = host;
    var map = {};
    try {
      map = JSON.parse(box.querySelector('[data-animall-reabasto-variantes]').textContent);
    } catch (e) { map = {}; }

    function show(text, kind) {
      msg.textContent = text || '';
      msg.className = 'animall-reabasto__msg' + (kind ? ' animall-reabasto__msg--' + kind : '');
      msg.hidden = !text;
    }

    function setVariant(id) {
      if (!id) return;
      id = String(id);
      if (id === variantInput.value && box.getAttribute('data-init') === '1') return;
      box.setAttribute('data-init', '1');
      variantInput.value = id;
      var agotada = map[id] === false;
      box.hidden = !agotada;
      form.hidden = false;
      button.disabled = false;
      show('', '');
    }

    // Dawn: updateVariantInput() cambia input[name="id"] y dispara "change" (burbujea).
    scope.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.name === 'id' && t.form && (t.form.getAttribute('data-type') === 'add-to-cart-form' || /^product-form-/.test(t.form.id || ''))) {
        setVariant(t.value);
      }
    });
    // Dawn reciente: pub/sub variant-change.
    if (typeof window.subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      window.subscribe(PUB_SUB_EVENTS.variantChange, function (ev) {
        var v = ev && ev.data && ev.data.variant;
        if (v && v.id) setVariant(v.id);
      });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var value = (email.value || '').trim();
      if (!EMAIL_RE.test(value)) {
        show('Revisa tu correo, parece incompleto.', 'error');
        email.focus();
        return;
      }
      button.disabled = true;
      show('Registrando tu aviso…', '');
      var company = encodeURIComponent(box.getAttribute('data-company-id'));
      var headers = {
        'Content-Type': 'application/vnd.api+json',
        'Accept': 'application/vnd.api+json',
        'revision': REVISION
      };
      function post(url, payload) {
        return fetch(url + company, { method: 'POST', headers: headers, body: JSON.stringify(payload) })
          .then(function (r) { return r.status === 202 || r.ok; })
          .catch(function () { return false; });
      }
      // 1) Aviso de reabasto: siempre (no depende de la casilla).
      var bis = post(ENDPOINT, {
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            profile: { data: { type: 'profile', attributes: { email: value } } },
            channels: ['EMAIL']
          },
          relationships: {
            variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantInput.value } }
          }
        }
      });
      // 2) Newsletter: solo si la persona marcó la casilla (desmarcada por defecto).
      var quiere = !!(optin && optin.checked && box.getAttribute('data-list-id'));
      var news = quiere ? post(ENDPOINT_NEWSLETTER, {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Aviso de reabasto (ficha agotada)',
            profile: { data: { type: 'profile', attributes: {
              email: value,
              subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
            } } }
          },
          relationships: { list: { data: { type: 'list', id: box.getAttribute('data-list-id') } } }
        }
      }) : Promise.resolve(null);
      Promise.all([bis, news]).then(function (res) {
        if (!res[0]) {
          button.disabled = false;
          show('No pudimos registrar tu aviso. Intenta de nuevo o escríbenos por WhatsApp al 55 2043 2076.', 'error');
          return;
        }
        form.hidden = true;
        var texto = '¡Listo! Te escribiremos a ' + value + ' en cuanto vuelva.';
        if (res[1] === true) texto += ' Revisa tu correo para confirmar tu suscripción a novedades.';
        if (res[1] === false) texto += ' Tu aviso quedó registrado, pero no pudimos suscribirte a novedades; puedes intentarlo más tarde.';
        show(texto, 'ok');
      });
    });
  }

  function boot() {
    var boxes = document.querySelectorAll('[data-animall-reabasto]');
    for (var i = 0; i < boxes.length; i++) init(boxes[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
